








import { defineComponent } from '~/utils/nuxt3-migration'
import { ciCheckCircle } from '~/icons/source/solid/check-circle'

export default defineComponent({
  props: {
    colorClass: {
      type: String,
      required: false,
      default: 'tw-text-primary'
    }
  },
  setup() {
    return { ciCheckCircle }
  }
})
